/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="95.58"
        height="95.5"
        viewBox="0 0 95.58 95.5"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <defs>
          <mask
            id="af3e9377-9e5b-41ac-b8cb-c30d351ca27e"
            x="23.13"
            y="0.99"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-29.87 -28.83)">
              <path
                d="M61.13,39.2v2.5A1.18,1.18,0,0,0,62.39,43h0a1.18,1.18,0,0,0,1.25-1.25h0V39.2A1.26,1.26,0,0,0,62.39,38h0a1.18,1.18,0,0,0-1.26,1.25Z"
                fill="#fff"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="adfb91ff-71ec-4481-a0d3-2f020ba39cb5"
            x="16.96"
            y="0.99"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-29.87 -28.83)">
              <path
                d="M55,39.2v2.5A1.18,1.18,0,0,0,56.21,43h0a1.18,1.18,0,0,0,1.26-1.25h0V39.2A1.35,1.35,0,0,0,56.21,38h0A1.18,1.18,0,0,0,55,39.2Z"
                fill="#fff"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="aef9ebbb-0936-42d1-b9b9-02a50f0efb43"
            x="10.66"
            y="0.99"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-29.87 -28.83)">
              <path
                d="M48.66,39.2v2.5A1.18,1.18,0,0,0,49.92,43h0a1.19,1.19,0,0,0,1.26-1.25h0V39.2A1.35,1.35,0,0,0,49.92,38h0a1.18,1.18,0,0,0-1.26,1.25Z"
                fill="#fff"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="b25213fc-0ef9-40b0-9fbd-f3f89f99aeef"
            x="23.13"
            y="11.37"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-29.87 -28.83)">
              <path
                d="M61.13,49.58v2.5a1.18,1.18,0,0,0,1.26,1.25h0a1.18,1.18,0,0,0,1.25-1.25h0v-2.5a1.18,1.18,0,0,0-1.25-1.25h0a1.18,1.18,0,0,0-1.26,1.25Z"
                fill="#fff"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="fb6a1380-7e9f-4fd5-9ee4-8bb111d07a3d"
            x="16.96"
            y="11.37"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-29.87 -28.83)">
              <path
                d="M55,49.58v2.5a1.18,1.18,0,0,0,1.25,1.25h0a1.18,1.18,0,0,0,1.26-1.25h0v-2.5a1.26,1.26,0,0,0-1.26-1.25h0A1.18,1.18,0,0,0,55,49.58Z"
                fill="#fff"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="bd1dc18f-01ef-415a-8046-a74d30759b73"
            x="10.66"
            y="11.37"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-29.87 -28.83)">
              <path
                d="M48.66,49.58v2.5a1.18,1.18,0,0,0,1.26,1.25h0a1.19,1.19,0,0,0,1.26-1.25h0v-2.5a1.26,1.26,0,0,0-1.26-1.25h0a1.18,1.18,0,0,0-1.26,1.25Z"
                fill="#fff"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="b825ddb1-1a99-4fd0-9869-764cfbd8d7cd"
            x="16.96"
            y="21.62"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-29.87 -28.83)">
              <path
                d="M55,59.83v2.5a1.18,1.18,0,0,0,1.25,1.25h0a1.18,1.18,0,0,0,1.26-1.25h0v-2.5a1.26,1.26,0,0,0-1.26-1.25h0A1.18,1.18,0,0,0,55,59.83Z"
                fill="#fff"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="f1245516-9344-43f3-909d-8bb020d3a53e"
            x="10.66"
            y="21.62"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-29.87 -28.83)">
              <path
                d="M48.66,59.83v2.5a1.18,1.18,0,0,0,1.26,1.25h0a1.19,1.19,0,0,0,1.26-1.25h0v-2.5a1.26,1.26,0,0,0-1.26-1.25h0a1.18,1.18,0,0,0-1.26,1.25Z"
                fill="#fff"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="a1a9bd70-1837-4446-af4b-06cc1fc34c74"
            x="16.96"
            y="31.87"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-29.87 -28.83)">
              <path
                d="M55,70.08v2.5a1.18,1.18,0,0,0,1.25,1.25h0a1.18,1.18,0,0,0,1.26-1.25h0v-2.5a1.35,1.35,0,0,0-1.26-1.25h0A1.18,1.18,0,0,0,55,70.08Z"
                fill="#fff"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="e324ce53-7e9d-4842-a623-954885db0b61"
            x="10.66"
            y="31.87"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-29.87 -28.83)">
              <path
                d="M48.66,70.08v2.5a1.18,1.18,0,0,0,1.26,1.25h0a1.19,1.19,0,0,0,1.26-1.25h0v-2.5a1.35,1.35,0,0,0-1.26-1.25h0a1.18,1.18,0,0,0-1.26,1.25Z"
                fill="#fff"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="b187bb75-d2a2-4726-b390-881e018a085d"
            x="16.96"
            y="42.25"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-29.87 -28.83)">
              <path
                d="M55,80.46V83a1.18,1.18,0,0,0,1.25,1.25h0A1.18,1.18,0,0,0,57.47,83h0v-2.5a1.26,1.26,0,0,0-1.26-1.25h0A1.18,1.18,0,0,0,55,80.46Z"
                fill="#fff"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="ebaf9c51-f062-4e2d-a7f0-080f0967248a"
            x="10.66"
            y="42.25"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-29.87 -28.83)">
              <path
                d="M48.66,80.46V83a1.18,1.18,0,0,0,1.26,1.25h0A1.19,1.19,0,0,0,51.18,83h0v-2.5a1.26,1.26,0,0,0-1.26-1.25h0a1.18,1.18,0,0,0-1.26,1.25Z"
                fill="#fff"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="aca81562-5ec4-4901-95b0-e95b63ca3042"
            x="45.04"
            y="30.46"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-29.87 -28.83)">
              <path
                d="M83,68.67v2.5a1.18,1.18,0,0,0,1.26,1.25h0a1.18,1.18,0,0,0,1.26-1.25h0v-2.5a1.26,1.26,0,0,0-1.26-1.25h0A1.18,1.18,0,0,0,83,68.67Z"
                fill="#fff"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="b9553777-e5e9-4c00-9d9f-0851b3e19b25"
            x="38.87"
            y="30.46"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-29.87 -28.83)">
              <path
                d="M76.87,68.67v2.5a1.18,1.18,0,0,0,1.26,1.25h0a1.19,1.19,0,0,0,1.26-1.25h0v-2.5a1.35,1.35,0,0,0-1.26-1.25h0a1.18,1.18,0,0,0-1.26,1.25Z"
                fill="#fff"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="a151ef66-4074-458b-a4fa-7be5dd36da0b"
            x="32.57"
            y="30.46"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-29.87 -28.83)">
              <path
                d="M70.57,68.67v2.5a1.19,1.19,0,0,0,1.26,1.25h0a1.18,1.18,0,0,0,1.26-1.25h0v-2.5a1.35,1.35,0,0,0-1.26-1.25h0a1.19,1.19,0,0,0-1.26,1.25Z"
                fill="#fff"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="ae57749d-010e-491a-a470-acf2485a1315"
            x="45.04"
            y="40.84"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-29.87 -28.83)">
              <path
                d="M83,79.05v2.5A1.18,1.18,0,0,0,84.3,82.8h0a1.18,1.18,0,0,0,1.26-1.25h0v-2.5A1.18,1.18,0,0,0,84.3,77.8h0A1.18,1.18,0,0,0,83,79.05Z"
                fill="#fff"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="b745385e-bfb8-444e-b9e6-8cfadc801132"
            x="38.87"
            y="40.84"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-29.87 -28.83)">
              <path
                d="M76.87,79.05v2.5a1.18,1.18,0,0,0,1.26,1.25h0a1.19,1.19,0,0,0,1.26-1.25h0v-2.5a1.26,1.26,0,0,0-1.26-1.25h0a1.18,1.18,0,0,0-1.26,1.25Z"
                fill="#fff"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="f6783bd4-5c22-4c8f-aa58-1461c0c3100f"
            x="32.57"
            y="40.84"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-29.87 -28.83)">
              <path
                d="M70.57,79.05v2.5a1.19,1.19,0,0,0,1.26,1.25h0a1.18,1.18,0,0,0,1.26-1.25h0v-2.5a1.26,1.26,0,0,0-1.26-1.25h0a1.19,1.19,0,0,0-1.26,1.25Z"
                fill="#fff"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="f1c9a4e4-3c94-4b27-8560-11db8bf318d5"
            x="45.04"
            y="51.09"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-29.87 -28.83)">
              <path
                d="M83,89.3v2.5a1.18,1.18,0,0,0,1.26,1.25h0a1.18,1.18,0,0,0,1.26-1.25h0V89.3a1.18,1.18,0,0,0-1.26-1.25h0A1.18,1.18,0,0,0,83,89.3Z"
                fill="#fff"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="ac781d60-eca8-4172-abfb-6a0f1cb2e0e8"
            x="38.87"
            y="51.09"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-29.87 -28.83)">
              <path
                d="M76.87,89.3v2.5a1.18,1.18,0,0,0,1.26,1.25h0a1.19,1.19,0,0,0,1.26-1.25h0V89.3a1.26,1.26,0,0,0-1.26-1.25h0a1.18,1.18,0,0,0-1.26,1.25Z"
                fill="#fff"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="fad1b458-a066-4768-85a3-508580264b68"
            x="32.57"
            y="51.09"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-29.87 -28.83)">
              <path
                d="M70.57,89.3v2.5a1.19,1.19,0,0,0,1.26,1.25h0a1.18,1.18,0,0,0,1.26-1.25h0V89.3a1.26,1.26,0,0,0-1.26-1.25h0a1.19,1.19,0,0,0-1.26,1.25Z"
                fill="#fff"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="bbdee47c-ac8c-4348-99a3-176e2b643e6a"
            x="45.04"
            y="61.34"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-29.87 -28.83)">
              <path
                d="M83,99.55v2.5a1.18,1.18,0,0,0,1.26,1.25h0a1.18,1.18,0,0,0,1.26-1.25h0v-2.5A1.25,1.25,0,0,0,84.3,98.3h0A1.18,1.18,0,0,0,83,99.55Z"
                fill="#fff"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="a08323b2-4c39-44b1-8ab6-5e197ce9c233"
            x="38.87"
            y="61.34"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-29.87 -28.83)">
              <path
                d="M76.87,99.55v2.5a1.18,1.18,0,0,0,1.26,1.25h0a1.19,1.19,0,0,0,1.26-1.25h0v-2.5a1.35,1.35,0,0,0-1.26-1.25h0a1.18,1.18,0,0,0-1.26,1.25Z"
                fill="#fff"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="a8d68d52-8de0-4152-9cc8-3009a6ac21a6"
            x="32.57"
            y="61.34"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-29.87 -28.83)">
              <path
                d="M70.57,99.55v2.5a1.19,1.19,0,0,0,1.26,1.25h0a1.18,1.18,0,0,0,1.26-1.25h0v-2.5a1.35,1.35,0,0,0-1.26-1.25h0a1.19,1.19,0,0,0-1.26,1.25Z"
                fill="#fff"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="b48d7e08-6de9-46d8-8c35-35e9dee1b10e"
            x="45.04"
            y="71.71"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-29.87 -28.83)">
              <path
                d="M83,109.92v2.5a1.18,1.18,0,0,0,1.26,1.25h0a1.18,1.18,0,0,0,1.26-1.25h0v-2.5a1.18,1.18,0,0,0-1.26-1.25h0A1.18,1.18,0,0,0,83,109.92Z"
                fill="#fff"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="b8f4f150-fb3d-4ea3-bedc-58dba7ed6465"
            x="38.87"
            y="71.71"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-29.87 -28.83)">
              <path
                d="M76.87,109.92v2.5a1.18,1.18,0,0,0,1.26,1.25h0a1.19,1.19,0,0,0,1.26-1.25h0v-2.5a1.26,1.26,0,0,0-1.26-1.25h0a1.18,1.18,0,0,0-1.26,1.25Z"
                fill="#fff"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="b7718a0d-4724-4b1d-be35-2101ba1a5314"
            x="32.57"
            y="71.71"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-29.87 -28.83)">
              <path
                d="M70.57,109.92v2.5a1.19,1.19,0,0,0,1.26,1.25h0a1.18,1.18,0,0,0,1.26-1.25h0v-2.5a1.26,1.26,0,0,0-1.26-1.25h0a1.19,1.19,0,0,0-1.26,1.25Z"
                fill="#fff"
                fillRule="evenodd"/>
            </g>
          </mask>
        </defs>
        <path
          d="M70,28.83A1.26,1.26,0,0,1,71.25,30v28a1.25,1.25,0,0,1-2.49.13V31.33H43.55v59.5H62.71A1.26,1.26,0,0,1,64,92v.13a1.24,1.24,0,0,1-1.12,1.24H42.3a1.24,1.24,0,0,1-1.24-1.12V30.08a1.26,1.26,0,0,1,1.12-1.25H70Z"
          transform="translate(-29.87 -28.83)"
          fill="#0e497b"
          className="icon-fill icon-base"/><path
          d="M62.39,38a1.18,1.18,0,0,0-1.26,1.25v2.5a1.26,1.26,0,0,0,2.51,0V39.2A1.26,1.26,0,0,0,62.39,38"
          transform="translate(-29.87 -28.83)"
          fill="#fcb51a"
          fillRule="evenodd"/><g mask="url(#af3e9377-9e5b-41ac-b8cb-c30d351ca27e)">
          <polygon
            points="23.13 22.26 41.91 22.26 41.91 0.99 23.13 0.99 23.13 22.26"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M56.21,38A1.18,1.18,0,0,0,55,39.2v2.5a1.26,1.26,0,0,0,2.51,0V39.2A1.35,1.35,0,0,0,56.21,38"
          transform="translate(-29.87 -28.83)"
          fill="#fcb51a"
          fillRule="evenodd"/><g mask="url(#adfb91ff-71ec-4481-a0d3-2f020ba39cb5)">
          <polygon
            points="16.95 22.26 35.74 22.26 35.74 0.99 16.95 0.99 16.95 22.26"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M49.92,38a1.18,1.18,0,0,0-1.26,1.25v2.5a1.26,1.26,0,0,0,2.52,0V39.2A1.35,1.35,0,0,0,49.92,38"
          transform="translate(-29.87 -28.83)"
          fill="#fcb51a"
          fillRule="evenodd"/><g mask="url(#aef9ebbb-0936-42d1-b9b9-02a50f0efb43)">
          <polygon
            points="10.66 22.26 29.44 22.26 29.44 0.99 10.66 0.99 10.66 22.26"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M62.39,48.33a1.18,1.18,0,0,0-1.26,1.25v2.5a1.26,1.26,0,0,0,2.51,0v-2.5a1.18,1.18,0,0,0-1.25-1.25"
          transform="translate(-29.87 -28.83)"
          fill="#fcb51a"
          fillRule="evenodd"/><g mask="url(#b25213fc-0ef9-40b0-9fbd-f3f89f99aeef)">
          <polygon
            points="23.13 32.63 41.91 32.63 41.91 11.37 23.13 11.37 23.13 32.63"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M56.21,48.33A1.18,1.18,0,0,0,55,49.58v2.5a1.26,1.26,0,0,0,2.51,0v-2.5a1.26,1.26,0,0,0-1.26-1.25"
          transform="translate(-29.87 -28.83)"
          fill="#fcb51a"
          fillRule="evenodd"/><g mask="url(#fb6a1380-7e9f-4fd5-9ee4-8bb111d07a3d)">
          <polygon
            points="16.95 32.63 35.74 32.63 35.74 11.37 16.95 11.37 16.95 32.63"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M49.92,48.33a1.18,1.18,0,0,0-1.26,1.25v2.5a1.26,1.26,0,0,0,2.52,0v-2.5a1.26,1.26,0,0,0-1.26-1.25"
          transform="translate(-29.87 -28.83)"
          fill="#fcb51a"
          fillRule="evenodd"/><g mask="url(#bd1dc18f-01ef-415a-8046-a74d30759b73)">
          <polygon
            points="10.66 32.63 29.44 32.63 29.44 11.37 10.66 11.37 10.66 32.63"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M56.21,58.58A1.18,1.18,0,0,0,55,59.83v2.5a1.26,1.26,0,0,0,2.51,0v-2.5a1.26,1.26,0,0,0-1.26-1.25"
          transform="translate(-29.87 -28.83)"
          fill="#fcb51a"
          fillRule="evenodd"/><g mask="url(#b825ddb1-1a99-4fd0-9869-764cfbd8d7cd)">
          <polygon
            points="16.95 42.88 35.74 42.88 35.74 21.62 16.95 21.62 16.95 42.88"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M49.92,58.58a1.18,1.18,0,0,0-1.26,1.25v2.5a1.26,1.26,0,0,0,2.52,0v-2.5a1.26,1.26,0,0,0-1.26-1.25"
          transform="translate(-29.87 -28.83)"
          fill="#fcb51a"
          fillRule="evenodd"/><g mask="url(#f1245516-9344-43f3-909d-8bb020d3a53e)">
          <polygon
            points="10.66 42.88 29.44 42.88 29.44 21.62 10.66 21.62 10.66 42.88"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M56.21,68.83A1.18,1.18,0,0,0,55,70.08v2.5a1.26,1.26,0,0,0,2.51,0v-2.5a1.35,1.35,0,0,0-1.26-1.25"
          transform="translate(-29.87 -28.83)"
          fill="#fcb51a"
          fillRule="evenodd"/><g mask="url(#a1a9bd70-1837-4446-af4b-06cc1fc34c74)">
          <polygon
            points="16.95 53.13 35.74 53.13 35.74 31.87 16.95 31.87 16.95 53.13"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M49.92,68.83a1.18,1.18,0,0,0-1.26,1.25v2.5a1.26,1.26,0,0,0,2.52,0v-2.5a1.35,1.35,0,0,0-1.26-1.25"
          transform="translate(-29.87 -28.83)"
          fill="#fcb51a"
          fillRule="evenodd"/><g mask="url(#e324ce53-7e9d-4842-a623-954885db0b61)">
          <polygon
            points="10.66 53.13 29.44 53.13 29.44 31.87 10.66 31.87 10.66 53.13"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M56.21,79.21A1.18,1.18,0,0,0,55,80.46V83a1.26,1.26,0,0,0,2.51,0v-2.5a1.26,1.26,0,0,0-1.26-1.25"
          transform="translate(-29.87 -28.83)"
          fill="#fcb51a"
          fillRule="evenodd"/><g mask="url(#b187bb75-d2a2-4726-b390-881e018a085d)">
          <polygon
            points="16.95 63.51 35.74 63.51 35.74 42.24 16.95 42.24 16.95 63.51"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M49.92,79.21a1.18,1.18,0,0,0-1.26,1.25V83a1.26,1.26,0,0,0,2.52,0v-2.5a1.26,1.26,0,0,0-1.26-1.25"
          transform="translate(-29.87 -28.83)"
          fill="#fcb51a"
          fillRule="evenodd"/><g mask="url(#ebaf9c51-f062-4e2d-a7f0-080f0967248a)">
          <polygon
            points="10.66 63.51 29.44 63.51 29.44 42.24 10.66 42.24 10.66 63.51"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><g>
          <path
            d="M124.2,121.83a1.25,1.25,0,0,1,.13,2.5H31.12a1.25,1.25,0,0,1-.13-2.49H124.2Z"
            transform="translate(-29.87 -28.83)"
            fill="#0e497b"
            className="icon-fill icon-base"/>
          <path
            d="M118.52,86.83a1.25,1.25,0,0,1,.12,2.49H92.33a1.25,1.25,0,0,1-.13-2.49h26.32Z"
            transform="translate(-29.87 -28.83)"
            fill="#0e497b"
            className="icon-fill icon-base"/>
          <path
            d="M110.85,34.7a1.25,1.25,0,0,1,1.24,1.13v43.5a1.25,1.25,0,0,1-2.49.13V37.2H86.16V50.77A1.25,1.25,0,0,1,85,52h-.13a1.26,1.26,0,0,1-1.25-1.12V36a1.25,1.25,0,0,1,1.12-1.24h26.07Z"
            transform="translate(-29.87 -28.83)"
            fill="#0e497b"
            className="icon-fill icon-base"/>
          <path
            d="M63.89,90.83A1.25,1.25,0,0,1,64,93.32h-26V123a1.27,1.27,0,0,1-1.13,1.25H36.8a1.26,1.26,0,0,1-1.25-1.12v-31a1.24,1.24,0,0,1,1.12-1.24H63.89Z"
            transform="translate(-29.87 -28.83)"
            fill="#0e497b"
            className="icon-fill icon-base"/>
          <path
            d="M91.66,45.84a1.25,1.25,0,0,1,1.82,1V123a1.25,1.25,0,0,1-2.49.13V49L65.26,62.42l-.11.06V123A1.26,1.26,0,0,1,64,124.23H63.9a1.24,1.24,0,0,1-1.24-1.12V61.75a1.27,1.27,0,0,1,.53-1l.11-.07.79-.43Z"
            transform="translate(-29.87 -28.83)"
            fill="#0e497b"
            className="icon-fill icon-base"/>
          <path
            d="M50.34,104.47a7.71,7.71,0,0,1,7.7,7.46v11a1.25,1.25,0,0,1-2.49.13V112.17A5.2,5.2,0,0,0,45.15,112v11a1.25,1.25,0,0,1-2.49.13V112.17A7.7,7.7,0,0,1,50.34,104.47Z"
            transform="translate(-29.87 -28.83)"
            fill="#0e497b"
            className="icon-fill icon-base"/>
          <path
            d="M84.3,67.42A1.18,1.18,0,0,0,83,68.67v2.5a1.26,1.26,0,0,0,2.52,0v-2.5a1.26,1.26,0,0,0-1.26-1.25"
            transform="translate(-29.87 -28.83)"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><g mask="url(#aca81562-5ec4-4901-95b0-e95b63ca3042)">
          <polygon
            points="45.04 51.73 63.82 51.73 63.82 30.46 45.04 30.46 45.04 51.73"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M78.13,67.42a1.18,1.18,0,0,0-1.26,1.25v2.5a1.26,1.26,0,0,0,2.52,0v-2.5a1.35,1.35,0,0,0-1.26-1.25"
          transform="translate(-29.87 -28.83)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g mask="url(#b9553777-e5e9-4c00-9d9f-0851b3e19b25)">
          <polygon
            points="38.87 51.73 57.65 51.73 57.65 30.46 38.87 30.46 38.87 51.73"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M71.83,67.42a1.19,1.19,0,0,0-1.26,1.25v2.5a1.26,1.26,0,0,0,2.52,0v-2.5a1.35,1.35,0,0,0-1.26-1.25"
          transform="translate(-29.87 -28.83)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g mask="url(#a151ef66-4074-458b-a4fa-7be5dd36da0b)">
          <polygon
            points="32.57 51.73 51.35 51.73 51.35 30.46 32.57 30.46 32.57 51.73"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M84.3,77.8A1.18,1.18,0,0,0,83,79.05v2.5a1.26,1.26,0,0,0,2.52,0v-2.5A1.18,1.18,0,0,0,84.3,77.8"
          transform="translate(-29.87 -28.83)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g mask="url(#ae57749d-010e-491a-a470-acf2485a1315)">
          <polygon
            points="45.04 62.1 63.82 62.1 63.82 40.84 45.04 40.84 45.04 62.1"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M78.13,77.8a1.18,1.18,0,0,0-1.26,1.25v2.5a1.26,1.26,0,0,0,2.52,0v-2.5a1.26,1.26,0,0,0-1.26-1.25"
          transform="translate(-29.87 -28.83)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g mask="url(#b745385e-bfb8-444e-b9e6-8cfadc801132)">
          <polygon
            points="38.87 62.1 57.65 62.1 57.65 40.84 38.87 40.84 38.87 62.1"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M71.83,77.8a1.19,1.19,0,0,0-1.26,1.25v2.5a1.26,1.26,0,0,0,2.52,0v-2.5a1.26,1.26,0,0,0-1.26-1.25"
          transform="translate(-29.87 -28.83)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g mask="url(#f6783bd4-5c22-4c8f-aa58-1461c0c3100f)">
          <polygon
            points="32.57 62.1 51.35 62.1 51.35 40.84 32.57 40.84 32.57 62.1"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M84.3,88.05A1.18,1.18,0,0,0,83,89.3v2.5a1.26,1.26,0,0,0,2.52,0V89.3a1.18,1.18,0,0,0-1.26-1.25"
          transform="translate(-29.87 -28.83)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g mask="url(#f1c9a4e4-3c94-4b27-8560-11db8bf318d5)">
          <polygon
            points="45.04 72.35 63.82 72.35 63.82 51.09 45.04 51.09 45.04 72.35"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M78.13,88.05a1.18,1.18,0,0,0-1.26,1.25v2.5a1.26,1.26,0,0,0,2.52,0V89.3a1.26,1.26,0,0,0-1.26-1.25"
          transform="translate(-29.87 -28.83)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g mask="url(#ac781d60-eca8-4172-abfb-6a0f1cb2e0e8)">
          <polygon
            points="38.87 72.35 57.65 72.35 57.65 51.09 38.87 51.09 38.87 72.35"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M71.83,88.05a1.19,1.19,0,0,0-1.26,1.25v2.5a1.26,1.26,0,0,0,2.52,0V89.3a1.26,1.26,0,0,0-1.26-1.25"
          transform="translate(-29.87 -28.83)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g mask="url(#fad1b458-a066-4768-85a3-508580264b68)">
          <polygon
            points="32.57 72.35 51.35 72.35 51.35 51.09 32.57 51.09 32.57 72.35"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M84.3,98.3A1.18,1.18,0,0,0,83,99.55v2.5a1.26,1.26,0,0,0,2.52,0v-2.5A1.25,1.25,0,0,0,84.3,98.3"
          transform="translate(-29.87 -28.83)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g mask="url(#bbdee47c-ac8c-4348-99a3-176e2b643e6a)">
          <polygon
            points="45.04 82.6 63.82 82.6 63.82 61.34 45.04 61.34 45.04 82.6"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M78.13,98.3a1.18,1.18,0,0,0-1.26,1.25v2.5a1.26,1.26,0,0,0,2.52,0v-2.5a1.35,1.35,0,0,0-1.26-1.25"
          transform="translate(-29.87 -28.83)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g mask="url(#a08323b2-4c39-44b1-8ab6-5e197ce9c233)">
          <polygon
            points="38.87 82.6 57.65 82.6 57.65 61.34 38.87 61.34 38.87 82.6"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M71.83,98.3a1.19,1.19,0,0,0-1.26,1.25v2.5a1.26,1.26,0,0,0,2.52,0v-2.5a1.35,1.35,0,0,0-1.26-1.25"
          transform="translate(-29.87 -28.83)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g mask="url(#a8d68d52-8de0-4152-9cc8-3009a6ac21a6)">
          <polygon
            points="32.57 82.6 51.35 82.6 51.35 61.34 32.57 61.34 32.57 82.6"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M84.3,108.67A1.18,1.18,0,0,0,83,109.92v2.5a1.26,1.26,0,0,0,2.52,0v-2.5a1.18,1.18,0,0,0-1.26-1.25"
          transform="translate(-29.87 -28.83)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g mask="url(#b48d7e08-6de9-46d8-8c35-35e9dee1b10e)">
          <polygon
            points="45.04 92.98 63.82 92.98 63.82 71.71 45.04 71.71 45.04 92.98"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M78.13,108.67a1.18,1.18,0,0,0-1.26,1.25v2.5a1.26,1.26,0,0,0,2.52,0v-2.5a1.26,1.26,0,0,0-1.26-1.25"
          transform="translate(-29.87 -28.83)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g mask="url(#b8f4f150-fb3d-4ea3-bedc-58dba7ed6465)">
          <polygon
            points="38.87 92.98 57.65 92.98 57.65 71.71 38.87 71.71 38.87 92.98"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M71.83,108.67a1.19,1.19,0,0,0-1.26,1.25v2.5a1.26,1.26,0,0,0,2.52,0v-2.5a1.26,1.26,0,0,0-1.26-1.25"
          transform="translate(-29.87 -28.83)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g mask="url(#b7718a0d-4724-4b1d-be35-2101ba1a5314)">
          <polygon
            points="32.57 92.98 51.35 92.98 51.35 71.71 32.57 71.71 32.57 92.98"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><g>
          <path
            d="M118.52,78.08a1.26,1.26,0,0,1,1.25,1.12V123a1.25,1.25,0,0,1-2.49.13V80.58H92.33a1.26,1.26,0,0,1-1.25-1.12v-.13a1.24,1.24,0,0,1,1.12-1.24h26.32Z"
            transform="translate(-29.87 -28.83)"
            fill="#0e497b"
            className="icon-fill icon-base"/>
          <path
            d="M118.51,95.58a1.25,1.25,0,0,1,.13,2.49H92.33a1.25,1.25,0,0,1-.13-2.49h26.31Z"
            transform="translate(-29.87 -28.83)"
            fill="#0e497b"
            className="icon-fill icon-base"/>
          <path
            d="M118.51,104.33a1.25,1.25,0,0,1,.13,2.5H92.33a1.25,1.25,0,0,1-.13-2.49h26.31Z"
            transform="translate(-29.87 -28.83)"
            fill="#0e497b"
            className="icon-fill icon-base"/>
          <path
            d="M118.51,113.08a1.25,1.25,0,0,1,.13,2.5H92.33a1.25,1.25,0,0,1-.13-2.49h26.31Z"
            transform="translate(-29.87 -28.83)"
            fill="#0e497b"
            className="icon-fill icon-base"/>
        </g>
      </svg>

    );
  }
}

Icon.displayName = 'CityscapeIcon';

export default Icon;
